import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewEncapsulation } from '@angular/core';
import { NgRedux, Select } from '@angular-redux3/store';
import { Observable } from 'rxjs';
import { PlaylistRemoteAppState } from '../../store';
import { environment } from '../../../environments/environment';
import { ListsModule } from '../../components/lists/lists.module';
import { SharedModule } from '../../shared.module';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { MatDialog } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { PipesModule } from '../../pipes/pipes.module';
import { HeaderModule } from '../../components/header/header.module';
import { ContainersModule } from '../containers.module';
import { Router } from '@angular/router';
import { ButtonsModule } from 'src/app/components/buttons/buttons.module';
import { MatButtonModule } from '@angular/material/button';
import { HistoryList } from '../../store/entities/historyList';

@Component({
  selector: 'mwo-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    ListsModule,
    SharedModule,
    AsyncPipe,
    CdkFixedSizeVirtualScroll,
    CdkVirtualForOf,
    CdkVirtualScrollViewport,
    NgForOf,
    MatRippleModule,
    PipesModule,
    NgIf,
    HeaderModule,
    ContainersModule,
    ButtonsModule,
    MatButtonModule
  ],
  encapsulation: ViewEncapsulation.None
})
export class HistoryListPage implements OnInit {
  @Select(['remote', 'name']) playerName$: Observable<string>;
  @Select('history') historyList$: Observable<HistoryList[]>;
  assetsUrl = `${environment.remoteApi}/${environment.apiVersion}/media/artwork/`;
  totalDuration = 0;
  totalLength = 0;

  constructor(private ngRedux: NgRedux<PlaylistRemoteAppState>,
    public dialog: MatDialog,
    private router: Router
   ) {
  }

  ngOnInit(): void {
    this.historyList$.subscribe((historyList) => {
      if (!historyList) {
        return;
      }
      this.totalLength = 0;
      this.totalDuration = 0;
      historyList.forEach((item) => {
        this.totalDuration += item?.media?.duration;
        this.totalLength++;
      });
    });
  }

  back() {
    this.router.navigate(['library']);
  }

}
